import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 10px 0;\n  display: flex;\n  position: relative;\n\n  input {\n    font-size: 16px;\n    width: 80% !important;\n    margin: 0;\n    border-color: transparent;\n  }\n\n  button {\n    width: 106px !important;\n    margin-top: 0;\n    padding: 15px;\n\n    svg {\n      width: 35px;\n    }\n  }\n\n  /* Error message */\n  p {\n    position: absolute;\n    bottom: -63%;\n    left: 0;\n    margin-bottom: 0;\n  }\n'], ['\n  margin: 10px 0;\n  display: flex;\n  position: relative;\n\n  input {\n    font-size: 16px;\n    width: 80% !important;\n    margin: 0;\n    border-color: transparent;\n  }\n\n  button {\n    width: 106px !important;\n    margin-top: 0;\n    padding: 15px;\n\n    svg {\n      width: 35px;\n    }\n  }\n\n  /* Error message */\n  p {\n    position: absolute;\n    bottom: -63%;\n    left: 0;\n    margin-bottom: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: ', ';\n'], ['\n  display: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: none;\n  color: ', ';\n  text-transform: uppercase;\n'], ['\n  display: none;\n  color: ', ';\n  text-transform: uppercase;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: ', ';\n  input[type=\'radio\'] {\n    margin-left: 0;\n    cursor: pointer;\n  }\n  label {\n    margin-right: 10px;\n  }\n\n  /* If touch device, flip it so sms is first, email second */\n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: ', ';\n  input[type=\'radio\'] {\n    margin-left: 0;\n    cursor: pointer;\n  }\n  label {\n    margin-right: 10px;\n  }\n\n  /* If touch device, flip it so sms is first, email second */\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n      flex-direction: row-reverse;\n      justify-content: ', ';\n    '], ['\n      flex-direction: row-reverse;\n      justify-content: ', ';\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: block;\n  margin-top: 10px;\n  font-size: 16px;\n  font-weight: 600;\n\n  @media (max-width: ', ') {\n    font-size: 15px;\n  }\n\n  input,\n  select {\n    margin-top: 5px;\n    border-color: ', ';\n  }\n'], ['\n  cursor: pointer;\n  display: block;\n  margin-top: 10px;\n  font-size: 16px;\n  font-weight: 600;\n\n  @media (max-width: ', ') {\n    font-size: 15px;\n  }\n\n  input,\n  select {\n    margin-top: 5px;\n    border-color: ', ';\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  input[type=\'radio\'] {\n    /* remove standard background appearance */\n    appearance: none;\n    /* create custom radiobutton appearance */\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    padding: 3px;\n    background-clip: content-box;\n    border: 1px solid ', ';\n    background-color: ', ';\n    border-radius: 50%;\n\n    &:checked {\n      background-color: ', ';\n    }\n  }\n'], ['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  input[type=\'radio\'] {\n    /* remove standard background appearance */\n    appearance: none;\n    /* create custom radiobutton appearance */\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    padding: 3px;\n    background-clip: content-box;\n    border: 1px solid ', ';\n    background-color: ', ';\n    border-radius: 50%;\n\n    &:checked {\n      background-color: ', ';\n    }\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  ', '\n'], ['\n  display: block;\n  width: 100%;\n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n      border: 2px solid ', ' !important;\n    '], ['\n      border: 2px solid ', ' !important;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n'], ['\n  font-weight: 600;\n  font-size: 15px;\n  color: ', ';\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']);

import React from 'react';
import styled, { css } from 'styled-components';
import MaskedInput from 'react-text-mask';

export var StyledFooterFormWrapper = styled.div(_templateObject);

export var StyledBtnArrowWrapper = styled.span(_templateObject2, function (_ref) {
  var isSubmitting = _ref.isSubmitting;
  return isSubmitting ? 'none' : 'inline-block';
});

export var StyledFooterFormSuccessSpan = styled.span(_templateObject3, function (props) {
  return props.theme.dormifyWhite;
});

export var StyledRadioGroup = styled.div(_templateObject4, function (props) {
  return props.align;
}, function (_ref2) {
  var isTouchDevice = _ref2.isTouchDevice;
  return isTouchDevice && css(_templateObject5, function (props) {
    return props.align === 'flex-start' && 'flex-end';
  });
});

export var StyledLabel = styled.label(_templateObject6, function (props) {
  return props.theme.mobileWidth;
}, function (props) {
  return props.theme.dormifyLightGrey;
});

export var StyledRadioLabel = styled.label(_templateObject7, function (props) {
  return props.theme.dormifyLightGrey;
}, function (props) {
  return props.theme.dormifyWhite;
}, function (props) {
  return props.theme.dormifyPink;
});

// eslint-disable-next-line no-unused-vars
var StyledTextInput = styled(function (_ref3) {
  var error = _ref3.error,
      props = _objectWithoutProperties(_ref3, ['error']);

  return React.createElement('input', props);
})(_templateObject8, function (_ref4) {
  var error = _ref4.error;
  return error && css(_templateObject9, function (props) {
    return props.theme.dormifyRed;
  });
});

// eslint-disable-next-line no-unused-vars
export { StyledTextInput };
var StyledMaskedInput = styled(function (_ref5) {
  var error = _ref5.error,
      props = _objectWithoutProperties(_ref5, ['error']);

  return React.createElement(MaskedInput, props);
})(_templateObject8, function (_ref6) {
  var error = _ref6.error;
  return error && css(_templateObject9, function (props) {
    return props.theme.dormifyRed;
  });
});

export { StyledMaskedInput };
export var StyledErrorMessage = styled.p(_templateObject10, function (props) {
  return props.theme.dormifyRed;
});

// eslint-disable-next-line no-unused-vars
var StyledSelect = styled(function (_ref7) {
  var placeholderText = _ref7.placeholderText,
      error = _ref7.error,
      props = _objectWithoutProperties(_ref7, ['placeholderText', 'error']);

  return React.createElement('select', props);
})(_templateObject11, function (_ref8) {
  var placeholderText = _ref8.placeholderText;
  return placeholderText && css(_templateObject12, function (props) {
    return props.theme.dormifyGrey;
  });
}, function (_ref9) {
  var error = _ref9.error;
  return error && css(_templateObject9, function (props) {
    return props.theme.dormifyRed;
  });
});
export { StyledSelect };